"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegisterStateValueProvider = useRegisterStateValueProvider;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const classifiers_1 = require("../../classifiers");
function useRegisterStateValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (0, classifiers_1.buildPublicDataValueProvider)({
        label: t('defaultClassifiers.registerState'),
        ...params,
        classifierName: 'registerState',
    });
}
